<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="this.$vuetify.lang.t('$vuetify.DASHBOARD.SESSIONS_TITLE')"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-expansion-panels v-model="filterExpansionPanel" flat multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $vuetify.lang.t('$vuetify.FILTERS') }}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="12" md="2" class="pt-0">
                      <v-text-field
                        v-model="placeName"
                        hide-details
                        :label="
                          $vuetify.lang.t('$vuetify.DASHBOARD.PLACE_NAME')
                        "
                        :aria-label="
                          $vuetify.lang.t('$vuetify.DASHBOARD.PLACE_NAME')
                        "
                        outlined
                      >
                        <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0">
                      <v-text-field
                        v-model="client"
                        hide-details
                        :label="$vuetify.lang.t('$vuetify.DASHBOARD.CLIENT')"
                        :aria-label="
                          $vuetify.lang.t('$vuetify.DASHBOARD.CLIENT')
                        "
                        outlined
                      >
                        <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0">
                      <v-text-field
                        v-model="carNumber"
                        hide-details
                        :label="
                          $vuetify.lang.t('$vuetify.DASHBOARD.CAR_NUMBER')
                        "
                        :aria-label="
                          $vuetify.lang.t('$vuetify.DASHBOARD.CAR_NUMBER')
                        "
                        outlined
                      >
                        <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
                      </v-text-field>
                    </v-col>
                    <v-col
                      ccols="12"
                      md="2"
                      sm="6"
                      class="pt-0 d-flex align-center"
                    >
                      <v-menu
                        v-model="validFromPicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="
                              selectedValidFrom !== ''
                                ? datePickerFormat(selectedValidFrom)
                                : ''
                            "
                            :label="$vuetify.lang.t('$vuetify.STATISTICS.FROM')"
                            :placeholder="
                              $vuetify.lang.t('$vuetify.STATISTICS.FROM')
                            "
                            append-icon="mdi-calendar"
                            readonly
                            outlined
                            hide-details
                            clearable
                            v-bind="attrs"
                            @click:clear="validFrom = null"
                            @click:append="validFromPicker = !validFromPicker"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="selectedValidFrom"
                          @input="validFromPicker = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      sm="6"
                      class="pt-0 d-flex align-center"
                    >
                      <v-menu
                        v-model="validToPicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :value="
                              selectedValidTo !== ''
                                ? datePickerFormat(selectedValidTo)
                                : ''
                            "
                            :label="$vuetify.lang.t('$vuetify.STATISTICS.TO')"
                            :placeholder="
                              $vuetify.lang.t('$vuetify.STATISTICS.TO')
                            "
                            append-icon="mdi-calendar"
                            readonly
                            outlined
                            hide-details
                            clearable
                            v-bind="attrs"
                            @click:clear="selectedValidTo = null"
                            @click:append="validToPicker = !validToPicker"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="selectedValidTo"
                          @input="validToPicker = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0">
                      <v-select
                        v-model="parkingStatus"
                        :items="parkingStatuses"
                        item-text="text"
                        item-value="name"
                        hide-details
                        :label="$vuetify.lang.t('$vuetify.STATUS')"
                        :menu-props="{
                          bottom: true,
                          offsetY: true
                        }"
                        outlined
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="2" class="pt-0">
                      <v-select
                        v-model="extraFilter"
                        :items="extraFilters"
                        item-text="text"
                        item-value="name"
                        hide-details
                        :label="$vuetify.lang.t('$vuetify.EXTRA_FILTER')"
                        :menu-props="{
                          bottom: true,
                          offsetY: true
                        }"
                        outlined
                        clearable
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                      sm="6"
                      class="pt-0 d-flex align-center"
                    >
                      <v-btn
                        color="success"
                        :loading="
                          loading.state && loading.type === 'getSessions'
                        "
                        :disabled="
                          loading.state && loading.type === 'getSessions'
                        "
                        @click="onSearchClick()"
                      >
                        {{ $vuetify.lang.t('$vuetify.SEARCH') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" md="1">
                      <v-select
                        v-model="selectedPageSize"
                        :items="[20, 50, 100, 200]"
                        :label="$vuetify.lang.t('$vuetify.STATISTICS.SHOW')"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row v-if="isGlobalAdmin">
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  color="success"
                  text
                  small
                  @click="startSessionDialog = true"
                >
                  <v-icon class="mr-2">mdi-plus</v-icon>Start new session
                </v-btn>
              </v-col>
            </v-row>
            <v-simple-table v-if="sessions.length > 0">
              <template
                v-slot:default
                :class="$vuetify.breakpoint.smAndDown ? 'd-none' : ''"
              >
                <thead>
                  <tr>
                    <th class="text-left">#</th>
                    <th class="text-left"></th>
                    <th class="secondary--text darken">
                      {{ $vuetify.lang.t('$vuetify.DASHBOARD.CAR_NUMBER') }}
                    </th>
                    <th class="secondary--text darken">
                      {{ $vuetify.lang.t('$vuetify.DASHBOARD.START_TIME') }}
                    </th>
                    <th class="secondary--text darken">
                      {{ $vuetify.lang.t('$vuetify.DASHBOARD.END_TIME') }}
                    </th>
                    <th class="secondary--text darken">
                      {{ $vuetify.lang.t('$vuetify.DASHBOARD.COST') }}
                    </th>
                    <th class="secondary--text darken">
                      {{ $vuetify.lang.t('$vuetify.DASHBOARD.CLIENT') }}
                    </th>
                    <th class="secondary--text darken">
                      {{ $vuetify.lang.t('$vuetify.DASHBOARD.PLACE') }}
                    </th>
                    <th class="text-right"></th>
                    <th v-if="isGlobalAdmin" class="text-right"></th>
                    <th v-if="isGlobalAdmin" class="text-right"></th>
                    <th
                      v-if="user.canEndParkingSessions"
                      class="text-right"
                    ></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in sessions" :key="item.name">
                    <td>
                      {{ item.OrderIndex }}
                    </td>
                    <td
                      data-label="Type"
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex align-center justify-space-between'
                          : ''
                      "
                    >
                      <v-tooltip v-if="isGlobalAdmin" bottom>
                        <template v-slot:activator="{ on }">
                          <div
                            :class="{
                              'primary--text': item.Type == 'PARKING',
                              'purple--text': item.Type == 'CAR_WASH'
                            }"
                            style="cursor: default;"
                            v-on="on"
                          >
                            {{ item.Type === 'PARKING' ? 'P' : 'W' }}
                          </div>
                        </template>
                        <span> ID={{ item.Id }} </span>
                      </v-tooltip>
                      <div
                        v-else
                        :class="{
                          'primary--text': item.Type == 'PARKING',
                          'purple--text': item.Type == 'CAR_WASH'
                        }"
                        @click="openEditSessionDialog(item)"
                      >
                        {{ item.Type === 'PARKING' ? 'P' : 'W' }}
                      </div>
                    </td>
                    <td
                      data-label="Car number"
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex align-center justify-space-between'
                          : ''
                      "
                    >
                      <div>
                        {{ item.CarNumber.length ? item.CarNumber : '-' }}
                      </div>
                    </td>
                    <td
                      data-label="Start time"
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex align-center justify-space-between'
                          : ''
                      "
                    >
                      {{ dateEE(item.StartTime) }}
                      <v-tooltip v-if="item.StartLprEventId > 0" bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            small
                            color="success"
                            @click="openLPREvent(item, 'start')"
                            v-on="on"
                          >
                            mdi-video
                          </v-icon>
                        </template>
                        <span>
                          Started by plate recognition event ({{
                            item.StartLprEventId
                          }})
                        </span>
                      </v-tooltip>
                    </td>
                    <td
                      data-label="End time"
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex align-center justify-space-between'
                          : ''
                      "
                    >
                      {{ dateEE(item.EndTime) }}
                      <v-tooltip v-if="item.EndLprEventId > 0" bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            small
                            color="success"
                            @click="openLPREvent(item, 'end')"
                            v-on="on"
                          >
                            mdi-video
                          </v-icon>
                        </template>
                        <span>
                          Ended by plate recognition event ({{
                            item.StartLprEventId
                          }})
                        </span>
                      </v-tooltip>
                    </td>
                    <td
                      data-label="Cost"
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex align-center justify-space-between'
                          : ''
                      "
                    >
                      <div>
                        {{
                          (item.CostInCents +
                            item.FreePassCentsUsed +
                            item.ServiceFeeCents +
                            (item.UsedFleetId > 0
                              ? item.HiddenCostInCents
                              : 0)) /
                            100
                        }}
                        {{ item.Currency }}
                      </div>
                      <span
                        v-if="
                          (isGlobalAdmin || isZoneAdmin || isRegionAdmin) &&
                            item.AppliedDiscountPercent > 0
                        "
                        class="d-flex align-center justify-center font-weight-bold caption"
                        style="background-color: #7f7e80; padding: 0px 8px; color: white; max-width: 60px; border-radius: 20px; width: 64px; height: 18px;"
                      >
                        -{{ item.AppliedDiscountPercent }}%
                      </span>
                    </td>
                    <td
                      data-label="Phone number"
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex align-center justify-space-between'
                          : ''
                      "
                    >
                      <div
                        :style="
                          isGlobalAdmin
                            ? 'cursor: pointer;'
                            : 'cursor: default;'
                        "
                        @click="openClientDialog(item)"
                      >
                        {{
                          item.Client.PhoneNumber.length
                            ? item.Client.PhoneNumber
                            : '-'
                        }}
                      </div>
                    </td>
                    <td
                      data-label="Place"
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex align-center justify-space-between'
                          : ''
                      "
                    >
                      <a
                        v-if="isGlobalAdmin"
                        style="color: #007CAD;"
                        href="javascript:void(0)"
                        @click="$router.push(`/place/${item.PlaceId}`)"
                      >
                        {{ item.Place.AddressText }}
                        {{ item.Place.Code.length ? ',' : '' }}
                        {{ item.Place.Code }}
                      </a>
                      <span v-else>
                        {{ item.Place.AddressText }}
                        {{ item.Place.Code.length ? ',' : '' }}
                        {{ item.Place.Code }}
                      </span>
                    </td>
                    <td
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex align-center justify-end'
                          : ''
                      "
                    >
                      <!-- <v-badge
                        v-if="isGlobalAdmin && item.PaymentStatus !== ''"
                        left
                        :color="badgeColor(item)"
                      >
                        <span slot="badge" class="font-weight-bold">
                          {{ item.PaymentStatus
                          }}{{
                            item.PaymentStatusCode > 0
                              ? '(' + item.PaymentStatusCode + ')'
                              : ''
                          }}
                        </span>
                      </v-badge> -->
                      <span
                        v-if="user.isAdmin && item.PaymentStatus !== ''"
                        left
                        :class="badgeColor(item)"
                        class="white--text font-weight-bold caption"
                        style="border-radius: 20px; padding: 4px 6px;"
                      >
                        {{ item.PaymentStatus
                        }}{{
                          item.PaymentStatusCode > 0
                            ? '(' + item.PaymentStatusCode + ')'
                            : ''
                        }}
                      </span>
                      <v-tooltip
                        v-if="
                          user.isAdmin &&
                            item.UsedDiscountCampaignCreditInCents > 0
                        "
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon color="blue darken-3" v-on="on">
                            mdi-gift-outline
                          </v-icon>
                        </template>
                        <span>
                          Used discount campaign credit:
                          {{ item.UsedDiscountCampaignCreditInCents / 100 }}
                          {{ item.Currency }}
                        </span>
                      </v-tooltip>
                      <v-tooltip v-if="item.UsedFreePassId !== 0" top>
                        <template v-slot:activator="{ on }">
                          <v-icon color="blue darken-3" v-on="on">
                            {{
                              item.UsedFleetId && item.UsedFleetId > 0
                                ? 'mdi-briefcase'
                                : 'mdi-calendar-month'
                            }}
                          </v-icon>
                        </template>
                        <span
                          v-if="
                            item.UsedFleetId &&
                              item.UsedFleetId > 0 &&
                              item.UsedFreePassId &&
                              item.UsedFreePassId > 0
                          "
                        >
                          {{ user.isAdmin ? item.UsedFleetName : 'Fleet' }}
                        </span>
                        <span v-else>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.DASHBOARD.PAID_WITH_MONTHLY_PASS'
                            )
                          }}
                        </span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="user.isAdmin && item.FreePassCentsUsed > 0"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            color="primary darken-3"
                            class="mx-2"
                            v-on="on"
                          >
                            mdi-piggy-bank
                          </v-icon>
                        </template>
                        <span>
                          {{ $vuetify.lang.t('$vuetify.DASHBOARD.CREDIT') }}
                        </span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="user.isAdmin && item.UsedCreditCardId > 0"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            color="accent darken-1"
                            class="mx-2"
                            v-on="on"
                          >
                            mdi-credit-card
                          </v-icon>
                        </template>
                        <span>
                          {{
                            $vuetify.lang.t(
                              '$vuetify.DASHBOARD.PAID_WITH_CREDITCARD'
                            )
                          }}
                        </span>
                      </v-tooltip>
                      <span
                        v-if="item.WhiteListedClient"
                        style="background-color: #4CAF50;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          width: 28px;
                          border-radius: 20px;
                          padding: 2px;"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon color="white" small v-on="on">
                              mdi-clipboard-list
                            </v-icon>
                          </template>
                          <span>
                            {{
                              $vuetify.lang.t('$vuetify.DASHBOARD.WHITELISTED')
                            }}
                          </span>
                        </v-tooltip>
                      </span>
                      <span
                        v-if="item.IsBundled"
                        style="background-color: #64B5F6;
                          width: 64px;
                          border-radius: 20px;
                          padding: 2px;"
                        class="d-inline-flex align-center justify-center"
                      >
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span
                              class="caption white--text font-weight-bold"
                              v-on="on"
                            >
                              BUNDLE
                            </span>
                          </template>
                          <span>
                            {{ item.BundleId }}
                          </span>
                        </v-tooltip>
                      </span>
                      <span v-if="item.BookingId > 0 && user.canViewBookings">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn icon @click="onBookingIconClick(item)">
                              <v-icon color="blue darken-3" v-on="on">
                                mdi-calendar
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{
                              $vuetify.lang.t('$vuetify.SESSION_WITH_BOOKING')
                            }}
                          </span>
                        </v-tooltip>
                      </span>
                    </td>
                    <td
                      v-if="isGlobalAdmin"
                      class="d-flex align-center justify-end"
                    >
                      <div class="d-flex align-center">
                        <v-btn
                          v-if="
                            (item.PaymentStatus === 'OK' ||
                              (item.IsBundled &&
                                item.PaymentStatus === 'PENDING') ||
                              item.FreePassCentsUsed > 0) &&
                              item.Region !== 'UKR' &&
                              item.Type != 'SUBSCRIPTION' &&
                              item.Type != 'CREDIT' &&
                              item.PaymentStatus !== 'REFUNDED'
                          "
                          color="accent"
                          x-small
                          @click="refund(item, index)"
                        >
                          Refund
                        </v-btn>
                        <v-btn
                          v-if="
                            item.SubscriptionPlanLimitType ==
                              'NUMBER_OF_SESSIONS' && item.Type != 'LOG'
                          "
                          color="accent"
                          x-small
                          @click="refundSubscriptionPlanUsedLimit(item, index)"
                        >
                          Refund
                        </v-btn>
                        <v-btn
                          v-if="
                            (item.PaymentStatus == 'ERROR' ||
                              item.PaymentStatus == 'TOO_BIG') &&
                              item.Type != 'CREDIT'
                          "
                          color="accent"
                          x-small
                          @click="retry(item, index)"
                        >
                          Retry
                        </v-btn>
                        <v-btn
                          v-if="
                            item.PaymentStatus == 'PENDING' &&
                              item.Region != 'UKR' &&
                              item.Type != 'SUBSCRIPTION' &&
                              item.Type != 'CREDIT' &&
                              item.PaymentStatus != 'REFUNDED'
                          "
                          color="secondary lighten-4"
                          x-small
                          @click="cancelSession(item, index)"
                        >
                          Cancel
                        </v-btn>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              :style="{
                                visibility: item.HasInvoice
                                  ? 'visible'
                                  : 'hidden'
                              }"
                              icon
                              class="ml-2"
                              @click="openInvoicesDialog(item)"
                              v-on="on"
                            >
                              <v-icon color="blue lighten-2">
                                mdi-receipt
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{ $vuetify.lang.t('$vuetify.DASHBOARD.INVOICE') }}
                          </span>
                        </v-tooltip>
                        <v-tooltip v-if="isGlobalAdmin" top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              class="ml-2"
                              @click="openPaymentLogsDialog(item)"
                              v-on="on"
                            >
                              <v-icon color="blue lighten-2">
                                mdi-math-log
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{
                              $vuetify.lang.t('$vuetify.DASHBOARD.PAYMENT_LOGS')
                            }}
                          </span>
                        </v-tooltip>
                      </div>
                    </td>
                    <td v-if="isGlobalAdmin">
                      <v-tooltip v-if="item.RatingId" top>
                        <template v-slot:activator="{ on }">
                          <v-rating
                            background-color="secondary lighten-4"
                            :value="item.Rating"
                            readonly
                            v-on="on"
                          ></v-rating>
                        </template>
                        <span> ID={{ item.RatingId }} </span>
                      </v-tooltip>
                    </td>
                    <td>
                      <div class="d-flex align-center justify-end">
                        <v-menu
                          v-if="
                            (user.canEndParkingSessions &&
                              item.Status === 'STARTED') ||
                              (item.BookingId <= 0 &&
                                item.BookableBookingProfileId &&
                                item.BookableBookingProfileId > 0)
                          "
                          offset-y
                          dense
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small v-bind="attrs" v-on="on">
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item
                              v-if="
                                user.canEndParkingSessions &&
                                  item.Status === 'STARTED'
                              "
                              @click="openEndSessionDialog(item)"
                            >
                              <v-list-item-title>
                                {{ $vuetify.lang.t('$vuetify.DELETE_SESSION') }}
                              </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="
                                item.BookingId <= 0 &&
                                  item.BookableBookingProfileId &&
                                  item.BookableBookingProfileId > 0
                              "
                              @click="onAddBookingQuickActionClick(item)"
                            >
                              <v-list-item-title>
                                {{
                                  $vuetify.lang.t(
                                    '$vuetify.BOOKING.ADD_BOOKING'
                                  )
                                }}
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                        <v-tooltip v-if="isGlobalAdmin" top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              class="secondary--text"
                              @click.stop="openEditSessionDialog(item)"
                              v-on="on"
                            >
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{ $vuetify.lang.t('$vuetify.EDIT_SESSION') }}
                          </span>
                        </v-tooltip>
                        <v-tooltip v-if="isGlobalAdmin" top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              icon
                              class="error--text"
                              @click.stop="onAskDeleteSession(item)"
                              v-on="on"
                            >
                              <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>
                            {{ $vuetify.lang.t('$vuetify.DELETE_SESSION') }}
                          </span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-toolbar v-else class="elevation-0 mt-12">
              <v-spacer></v-spacer>
              <v-progress-circular
                v-if="loading.state"
                indeterminate
                color="secondary"
              ></v-progress-circular>
              <div v-else>
                <span v-if="!sessions.length">No data</span>
              </div>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card-text>
        </v-card>
        <v-toolbar color="transparent" class="elevation-0">
          <v-spacer></v-spacer>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="currentPageNumber === 1"
            @click="prevPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-left</v-icon>
          </v-btn>
          <v-btn fab color="primary" class="secondary--text" x-small readonly>
            {{ currentPageNumber }}
          </v-btn>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="!nextAvailablePage || nextAvailablePage <= 0"
            @click="nextPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-col>
    </v-row>
    <invoices-dialog
      v-if="selectedSession"
      :session-id="selectedSession.Id"
      :visible="invoicesDialog"
      @close="
        selectedSession = null
        invoicesDialog = false
      "
    />
    <payment-logs-dialog
      v-if="selectedSession"
      :session-id="selectedSession.Id"
      :visible="paymentLogsDialog"
      @close="
        selectedSession = null
        paymentLogsDialog = false
      "
    />
    <edit-session-dialog
      v-if="selectedSession"
      :session="selectedSession"
      :visible="editSessionDialog"
      @close="
        selectedSession = null
        editSessionDialog = false
      "
    />
    <start-session-dialog
      v-if="startSessionDialog"
      :visible="startSessionDialog"
      @close="startSessionDialog = false"
    />
    <l-p-r-event-image-dialog
      v-if="selectedEventId"
      :event-id="selectedEventId"
      :visible="lprEventImageDialog"
      @close="
        lprEventImageDialog = false
        selectedEventId = null
      "
    />
    <client-dialog
      v-if="selectedSession && clientDialog"
      :client-id="selectedSession.Client.Id"
      :visible="clientDialog"
      @close="
        clientDialog = false
        selectedSession = null
      "
    />
    <end-session-dialog
      v-if="endSessionDialog && selectedSession"
      :session="selectedSession"
      :visible="endSessionDialog"
      @close="
        selectedSession = null
        endSessionDialog = false
      "
    />
    <edit-booking-dialog
      v-if="editBookingDialog"
      :title="
        selectedBooking.ID > 0
          ? $vuetify.lang.t('$vuetify.BOOKING.EDIT_BOOKING')
          : $vuetify.lang.t('$vuetify.BOOKING.ADD_NEW')
      "
      :visible="editBookingDialog"
      @close="editBookingDialog = false"
    />
    <v-dialog v-model="deleteSessionDialog" max-width="420">
      <v-card>
        <v-card-title
          class="body-1"
          style="background-color: #c8697e; color: white;"
        >
          <i
            aria-hidden="true"
            class="v-icon notranslate v-icon--left mdi mdi-alert theme--dark"
          ></i>
          {{ $vuetify.lang.t('$vuetify.ARE_YOU_SURE') || 'Delete session' }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem;">
          {{
            $vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE') ||
              'Are you sure you want to delete this session?'
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteSessionDialog = false">
            {{ $vuetify.lang.t('$vuetify.CANCEL') || 'Cancel' }}
          </v-btn>
          <v-btn text style="color: #FFC41F;" @click="confirmDeleteSession">
            {{ $vuetify.lang.t('$vuetify.YES') || 'Delete' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'
import Booking from '@/models/booking'

export default {
  name: 'Sessions',
  components: {
    InvoicesDialog: () =>
      import(
        /* webpackChunkName: "InvoicesDialog" */ '@/components/InvoicesDialog'
      ),
    PaymentLogsDialog: () =>
      import(
        /* webpackChunkName: "PaymentLogsDialog" */ '@/components/PaymentLogsDialog'
      ),
    EditSessionDialog: () =>
      import(
        /* webpackChunkName: "EditSessionDialog" */ '@/components/EditSessionDialog'
      ),
    StartSessionDialog: () =>
      import(
        /* webpackChunkName: "StartSessionDialog" */ '@/components/StartSessionDialog'
      ),
    LPREventImageDialog: () =>
      import(
        /* webpackChunkName: "LPREventImageDialog" */ '@/components/LPREventImageDialog'
      ),
    ClientDialog: () =>
      import(
        /* webpackChunkName: "ClientDialog" */ '@/components/ClientDialog'
      ),
    EndSessionDialog: () =>
      import(
        /* webpackChunkName: "EndSessionDialog" */ '@/components/EndSessionDialog'
      ),
    EditBookingDialog: () =>
      import(
        /* webpackChunkName: "EditBookingDialog" */ '@/components/booking/EditBookingDialog'
      )
  },
  mixins: [formatDate],
  data() {
    return {
      breadcrumbs: [
        {
          text: this.$vuetify.lang.t('$vuetify.DASHBOARD.SESSIONS_DESCRIPTION'),
          disabled: true
        }
      ],
      selectedPageSize: 20,
      invoicesDialog: false,
      selectedSession: null,
      paymentLogsDialog: false,
      editSessionDialog: false,
      startSessionDialog: false,
      placeName: '',
      client: '',
      carNumber: '',
      lprEventImageDialog: false,
      selectedEventId: null,
      clientDialog: false,
      filterExpansionPanel: [0],
      validFromPicker: false,
      selectedValidFrom: '',
      validToPicker: false,
      selectedValidTo: '',
      parkingStatus: '',
      extraFilter: '',
      endSessionDialog: false,
      editBookingDialog: false,
      deleteSessionDialog: false
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('authentication', [
      'user',
      'isAuthenticated',
      'isGlobalAdmin',
      'isRegionAdmin',
      'isZoneAdmin'
    ]),
    ...mapGetters('sessions', ['sessions', 'nextAvailablePage']),
    ...mapGetters('booking', ['selectedBooking', 'selectedBookingProfile']),
    currentPageNumber: {
      get() {
        return this.$store.state.app.currentPageNumber
      },
      set(val) {
        this.$store.commit('app/setCurrentPageNumber', val)
      }
    },
    parkingStatuses: {
      get() {
        return [
          {
            name: 'PARKING_ACTIVE',
            text: this.$vuetify.lang.t('$vuetify.PARKING_ACTIVE')
          },
          {
            name: 'PARKING_NOT_ACTIVE',
            text: this.$vuetify.lang.t('$vuetify.PARKING_NOT_ACTIVE')
          }
        ]
      }
    },
    extraFilters: {
      get() {
        return [
          {
            name: 'WITH_BOOKING',
            text: this.$vuetify.lang.t('$vuetify.WITH_BOOKING')
          },
          {
            name: 'WITHOUT_BOOKING',
            text: this.$vuetify.lang.t('$vuetify.WITHOUT_BOOKING')
          },
          {
            name: 'PARKING_SESSIONS_OVER_FREE_TIME',
            text: this.$vuetify.lang.t(
              '$vuetify.PARKING_SESSIONS_OVER_FREE_TIME'
            )
          }
        ]
      }
    }
  },
  created() {
    this.getSessions({
      page: this.currentPageNumber - 1,
      placeName: this.placeName,
      phoneNumber: this.client,
      carNumber: this.carNumber,
      status: this.parkingStatus,
      extraFilter: this.extraFilter,
      from:
        this.selectedValidFrom !== ''
          ? this.serverFormat(this.selectedValidFrom)
          : '',
      to:
        this.selectedValidTo !== ''
          ? this.serverFormat(this.selectedValidTo)
          : '',
      pageSize: this.selectedPageSize
    })
  },
  methods: {
    ...mapActions('sessions', [
      'getSessions',
      'getBooking',
      'deleteParkingSession'
    ]),
    ...mapActions('booking', [
      'getBooking',
      'getBookingProfiles',
      'getBookingProfile'
    ]),
    appendLeadingZeroes(n) {
      if (n <= 9) {
        return `0${n}`
      }
      return n
    },
    refund(session) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          const mutateSession = session
          mutateSession.PaymentStatus = 'REFUNDED'
          this.$store.dispatch('sessions/putSession', mutateSession)
        }
      })
    },
    refundSubscriptionPlanUsedLimit(session) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          const mutateSession = session
          mutateSession.Type = 'LOG'
          this.$store.dispatch('sessions/deleteSession', mutateSession)
        }
      })
    },
    cancelSession(session) {
      const mutateSession = session
      mutateSession.PaymentStatus = 'NOT_SENT'
      this.$store.dispatch('sessions/putSession', mutateSession)
    },
    retry(session) {
      const mutateSession = session
      mutateSession.PaymentStatus = ''
      this.$store.dispatch('sessions/putSession', mutateSession)
    },
    badgeColor(session) {
      let color = ''
      if (
        session.PaymentStatus === 'NOT_SENT' ||
        session.PaymentStatus === 'TEST'
      ) {
        color = 'secondary lighten-4'
      }
      if (session.PaymentStatus === 'OK') {
        color = 'success'
      }
      if (
        session.PaymentStatus === 'ERROR' ||
        session.PaymentStatus === 'REFUND_FAILED' ||
        session.PaymentStatus === 'PARTIAL_REFUND_FAILED'
      ) {
        color = 'error'
      }
      if (session.PaymentStatus === 'TOO_BIG') {
        color = 'warning'
      }
      if (
        session.PaymentStatus === 'REFUNDED' ||
        session.PaymentStatus === 'PARTIAL_REFUND_FAILED' ||
        session.PaymentStatus === 'REFUND_REQUESTED' ||
        session.PaymentStatus === 'PARTIAL_REFUND_REQUESTED'
      ) {
        color = 'blue lighten-2'
      }
      if (session.PaymentStatus === 'PENDING') {
        color = 'blue lighten-4'
      }
      if (session.PaymentStatus === 'PARTIALLY_REFUNDED') {
        color = 'blue lighten-2'
      }

      return color
    },
    nextPage() {
      this.currentPageNumber += 1
      this.getSessions({
        page: this.currentPageNumber - 1,
        placeName: this.placeName,
        phoneNumber: this.client,
        carNumber: this.carNumber,
        status: this.parkingStatus,
        extraFilter: this.extraFilter,
        from:
          this.selectedValidFrom !== ''
            ? this.serverFormat(this.selectedValidFrom)
            : '',
        to:
          this.selectedValidTo !== ''
            ? this.serverFormat(this.selectedValidTo)
            : '',
        pageSize: this.selectedPageSize
      })
    },
    prevPage() {
      if (this.currentPageNumber !== 1) {
        this.currentPageNumber -= 1
        this.getSessions({
          page: this.currentPageNumber - 1,
          placeName: this.placeName,
          phoneNumber: this.client,
          carNumber: this.carNumber,
          status: this.parkingStatus,
          extraFilter: this.extraFilter,
          from:
            this.selectedValidFrom !== ''
              ? this.serverFormat(this.selectedValidFrom)
              : '',
          to:
            this.selectedValidTo !== ''
              ? this.serverFormat(this.selectedValidTo)
              : '',
          pageSize: this.selectedPageSize
        })
      }
    },
    openInvoicesDialog(session) {
      this.selectedSession = session
      this.invoicesDialog = true
    },
    openPaymentLogsDialog(session) {
      this.selectedSession = session
      this.paymentLogsDialog = true
    },
    openEditSessionDialog(session) {
      if (this.isGlobalAdmin) {
        this.selectedSession = session
        this.editSessionDialog = true
      }
    },
    openEndSessionDialog(session) {
      if (this.user.canEndParkingSessions) {
        this.selectedSession = session
        this.endSessionDialog = true
      }
    },
    onAskDeleteSession(session) {
      if (this.isGlobalAdmin) {
        this.selectedSession = session
        this.deleteSessionDialog = true
      }
    },

    async confirmDeleteSession() {
      if (!this.selectedSession) {
        this.deleteSessionDialog = false
        return
      }

      await this.onDeleteSession(this.selectedSession)
      this.deleteSessionDialog = false
      this.selectedSession = null
    },

    async onDeleteSession(session) {
      try {
        await this.deleteParkingSession({
          Id: session.Id,
          Comments: 'Deleted from admin sessions UI',
          PaymentLogId: session.PaymentLogId
        })

        this.$store.commit(
          'app/setSnackbar',
          {
            show: true,
            type: 'success',
            message: 'Session deleted'
          },
          { root: true }
        )
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        // Error snackbar already handled in the action
      }
    },
    openLPREvent(session, time) {
      if (time === 'start') {
        this.selectedEventId = session.StartLprEventId
      } else if (time === 'end') {
        this.selectedEventId = session.EndLprEventId
      }
      this.selectedSession = session
      this.lprEventImageDialog = true
    },
    openClientDialog(session) {
      if (this.isGlobalAdmin) {
        this.selectedSession = session
        this.clientDialog = true
      }
    },
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
    },
    serverFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onBookingIconClick(session) {
      if (!this.user.canViewBookings) {
        return
      }
      this.getBooking({ this: this, bookingId: session.BookingId }).then(
        booking => {
          if (booking && booking.ID > 0) {
            const selectedBookingCopy = JSON.parse(JSON.stringify(booking))
            this.$store.commit(
              'booking/setSelectedBooking',
              selectedBookingCopy
            )
            this.$store.commit(
              'booking/setSelectedBookingProfileId',
              selectedBookingCopy.BookingProfileID
            )
          }
          this.editBookingDialog = true
        }
      )
    },
    async onAddBookingQuickActionClick(session) {
      this.getBookingProfile({
        this: this,
        bookingProfileId: session.BookableBookingProfileId
      }).then(bookablePlace => {
        const startTime = new Date(session.StartTime)
        const startTimeHours = String(startTime.getHours()).padStart(2, '0')
        const startTimeMinutes = String(startTime.getMinutes()).padStart(2, '0')
        this.$store.commit(
          'booking/setSelectedBookingProfileId',
          bookablePlace.BookingProfileID
        )
        this.$store.commit('booking/setSelectedBookingProfile', {
          ...bookablePlace,
          DefaultStartTimeHour: startTimeHours,
          DefaultStartTimeMinutes: startTimeMinutes
        })
        const booking = JSON.parse(JSON.stringify(new Booking().getObject()))
        booking.PlaceID = bookablePlace.PlaceID
        booking.LicensePlate = session.CarNumber
        this.$store.commit('booking/setSelectedBooking', booking)
        this.editBookingDialog = true
      })
    },
    hasSessionEnded(session) {
      const now = new Date()
      return new Date(session.EndTime) <= now
    },
    onSearchClick() {
      if (this.currentPageNumber > 1) {
        this.currentPageNumber = 1
      }
      this.getSessions({
        page: this.currentPageNumber - 1,
        placeName: this.placeName,
        phoneNumber: this.client,
        carNumber: this.carNumber,
        status: this.parkingStatus,
        extraFilter: this.extraFilter,
        from:
          this.selectedValidFrom !== ''
            ? this.serverFormat(this.selectedValidFrom)
            : '',
        to:
          this.selectedValidTo !== ''
            ? this.serverFormat(this.selectedValidTo)
            : '',
        pageSize: this.selectedPageSize
      })
    }
  }
}
</script>
<style scoped>
@media screen and (max-width: 959px) {
  table {
    border: 0;
  }

  table caption {
    font-size: 1.3em;
  }

  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  table tr {
    border-bottom: 1px solid #ddd;
    display: block;
    margin-bottom: 0.625em;
  }

  table td {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: 0.8em;
    text-align: right;
  }

  table td::before {
    /*
    * aria-label has no advantage, it won't be read inside a table
    content: attr(aria-label);
    */
    content: attr(data-label);
    float: left;
  }

  table td:last-child {
    border-bottom: 0;
  }
}
</style>
